// @ts-nocheck
export default {
    getBankName: (state) => (bankCode) => state.bankCode.find((it) => bankCode === it.detailCode)?.detailCodeName ?? '',
    bankItems: ({ bankCode }) => bankCode.map(({ detailCodeName, detailCode }) => ({
        text: detailCodeName,
        value: detailCode,
    })),
};
